import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Workplace = function Workplace(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$secondaryColor = _ref.secondaryColor,
    secondaryColorProp = _ref$secondaryColor === void 0 ? 'var(--color-primary-light-400)' : _ref$secondaryColor,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  var secondaryColor = !ignoreColor ? secondaryColorProp : undefined;
  return /*#__PURE__*/_jsxs("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M46 39H2V10H10V12H4V37H44V12H38V10H46V39Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M34 44H14V46H34V44Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M15 46V44C17.2375 44 19.1375 41.25 19.1375 38H21.1375C21.1375 42.4125 18.3875 46 15 46Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M33.0002 46C29.6127 46 26.8502 42.4125 26.8502 38H28.8502C28.8502 41.2 30.7877 44 33.0002 44V46Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M21 34H9V2H21V34ZM11 32H19V4H11V32Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M14 8H10V10H14V8Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M14 14H10V16H14V14Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M14 20H10V22H14V20Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M14 26H10V28H14V26Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M28 10H20V12H28V10Z",
      fill: color
    }), /*#__PURE__*/_jsx("path", {
      d: "M33 35.5625L27 26.3V8C27 4.6875 29.6875 2 33 2C36.3125 2 39 4.6875 39 8V26.3L33 35.5625ZM29 25.7L33 31.875L37 25.7V8C37 5.8 35.2 4 33 4C30.8 4 29 5.8 29 8V25.7Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M38 8H28V10H38V8Z",
      fill: secondaryColor
    }), /*#__PURE__*/_jsx("path", {
      d: "M38 25H28V27H38V25Z",
      fill: secondaryColor
    })]
  });
};
export default Workplace;